import { Group, Icon, Stack, Text } from '@inflearn/ds-react-next';
import { faCircleExclamation } from '@inflearn/pro-regular-svg-icons';

const NOTICES = [
  '운영 중인 모든 강의는 서비스에 공개된 시점으로부터 2년 이상이 되어야 합니다. 그렇지 않으면 누적 정산금의 30% 위약금이 발생합니다. [제11조 3항]',
  '탈퇴 승인 완료 후 운영 중인 모든 강의는 인프런 서비스에서 판매 중단됩니다. 단 기존 수강생에 한하여 강의 콘텐츠를 계속 이용할 수 있습니다. [제11조 4항]',
  '서비스 해지 1개월 전 통지 의무에 따라 탈퇴 신청일로부터 1개월 이내 탈퇴 처리됩니다. [제8조 3항]',
  '탈퇴 시점과 관계없이 미정산 수익금은 익월 10영업일에 정산됩니다.',
  '아직 진행하지 않은 멘토링 건이 있다면, 완료 후 탈퇴 신청해 주세요. 탈퇴 후에는 멘티에게 메시지 보내기 기능을 사용할 수 없습니다.',
  '위 내용에 동의하신다면, [탈퇴 신청서]를 작성해 주세요.',
];

export const InstructorNotice = () => {
  return (
    <Stack
      gap={4}
      p={12}
      bg="gray.0"
      styles={{
        root: { borderRadius: 8 },
      }}
      mt={12}
    >
      <Group align="center" gap={8}>
        <Icon icon={faCircleExclamation} size="sm" color="red.7" />
        <Text size="sm" fw={600} c="red.7">
          수익이 있는 지식공유자 추가 안내사항
        </Text>
      </Group>
      {NOTICES.map((notice, index) => (
        <Text key={notice} fz={14} c="gray.9">
          {index + 1}. {notice}
        </Text>
      ))}
    </Stack>
  );
};
